import { STATE_INITIAL } from 'Store/commonActions';

import type { VaultState } from './types';

const initialState: VaultState = {
  checkInvitationStatus: null,
  checkCodeStatus: STATE_INITIAL,
  codeRedemptionStatus: STATE_INITIAL,
  codeValidationStatus: STATE_INITIAL,
  redeemableCode: null,
  vaultConfig: null,
};

export default initialState;
